import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RightsService } from '../../../../services/rights.service';
import { TasksProcessingServiceState } from './../../../../services/dtos/tasksProcessingServiceState';
import { TasksService } from './../../../../services/tasks.service';

@Component({
  selector: 'app-task-header',
  templateUrl: './task-header.component.html',
  styleUrls: ['./task-header.component.scss']
})
export class TaskHeaderComponent implements OnInit, OnDestroy {
  public isTasksProcessingPaused = false;
  public canShowButtons = false;

  private subs = new Array<Subscription>();

  public constructor(public accessService: RightsService, private tasksService: TasksService) { }

  public ngOnInit(): void {
    this.subs.push(this.tasksService.getTasksProcessingServiceState().subscribe(
      (tasksProcessingServiceState: TasksProcessingServiceState) => {
        this.isTasksProcessingPaused = tasksProcessingServiceState.isTaskProcessingPaused;
        this.canShowButtons = true;
      }));
  }

  public ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  public pauseTasksProcessing(): void {
    this.tasksService.pauseTasksProcessingService().subscribe(() => this.isTasksProcessingPaused = true);
  }

  public startTasksProcessing(): void {
    this.tasksService.startTasksProcessingService().subscribe(() => this.isTasksProcessingPaused = false);
  }
}
